import api from 'config/axios';
import AppService from 'common/app-service';

export default class ProcessService extends AppService {
  constructor() {
    super('/dfes', api);
  }

  async triggerBatchProcessing(batchId: string) {
    const response = await this.api.post(`${this.servicePath}/processes`, { batch_id: batchId });

    return response.data;
  }
}
